/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface VisiteSearch
 */
export interface VisiteSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof VisiteSearch
     */
    lieu?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof VisiteSearch
     */
    accord?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof VisiteSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisiteSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof VisiteSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof VisiteSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VisiteSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof VisiteSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof VisiteSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the VisiteSearch interface.
 */
export function instanceOfVisiteSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VisiteSearchFromJSON(json: any): VisiteSearch {
    return VisiteSearchFromJSONTyped(json, false);
}

export function VisiteSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisiteSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lieu': !exists(json, 'lieu') ? undefined : TextSearchFromJSON(json['lieu']),
        'accord': !exists(json, 'accord') ? undefined : TextSearchFromJSON(json['accord']),
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function VisiteSearchToJSON(value?: VisiteSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lieu': TextSearchToJSON(value.lieu),
        'accord': TextSearchToJSON(value.accord),
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

